import * as React from "react";
import { SVGProps } from "react";
const SvgExternalLinkArrow = (props: SVGProps<SVGSVGElement>) => <svg width={17} height={16} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 16" {...props}><path d="M3.5 1.114h12v12M15.5 1l-14 14" stroke="currentColor" strokeWidth={2} fill="none" fillRule="evenodd" /></svg>;
export default SvgExternalLinkArrow;